import { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useSagaTakeLeading } from '../../../hooks/useSaga'
import { actions, selectors } from '../../../redux'
import { StepProps } from '../../../types'
import { useUser } from '../../User/useUser'
import { ActionButtonVariant } from '../../../components/ActionButton/styled'

export const useConfirmStep = (props: StepProps & { registrantName: string }) => {
  const { t, dispatch, registrantName } = props
  const { reset: resetUser } = useUser()
  const declarationConfirm = useSelector(selectors.declaration.saveDeclaration)
  // const formValues = useSelector(selectors.declaration.formValues)

  // Traitement des erreurs
  const processedError = useMemo(() => {
    // const regexSiren = /^\d{9}$/ // Siren
    // const regexRna = /^W\d{9}$/ // Rna Siren

    // const hasEmptySiren = formValues.items.some((item) => {
    //   console.log('item', item)
    //   if (item.type === 'FOREIGN_COMPANY') {
    //     return false
    //   }

    //   if (item.type === 'MANDATE') {
    //     const siren = item.siren ?? ''
    //     const rnaSiren = item.rnaSiren ?? ''

    //     return siren === '' || (!regexSiren.test(siren) && !regexRna.test(rnaSiren))
    //   }

    //   return (
    //     typeof item.siren === 'undefined' ||
    //     !regexSiren.test(item.siren) ||
    //     item.siren === '' ||
    //     item.siren === null
    //   )
    // })

    // if (hasEmptySiren) {
    //   return [
    //     {
    //       label: t('declaration.form.confirmation.siren'),
    //     },
    //   ]
    // }

    if (!declarationConfirm?.errors) return []

    let sirenErrorCount = 0

    for (const error of declarationConfirm.errors) {
      const label = error.label?.toLowerCase() || ''

      if (label.includes('siren') || label.includes('rna') || label.includes('siret')) {
        sirenErrorCount++
      }
    }

    if (sirenErrorCount === 1) {
      return [
        {
          label: t('declaration.form.confirmation.error'),
        },
      ]
    } else if (sirenErrorCount > 1) {
      return [
        {
          label: t('declaration.form.confirmation.siren'),
        },
      ]
    }

    return [
      {
        label: t('declaration.form.confirmation.unknowError'),
      },
    ]
  }, [declarationConfirm.errors, t])

  useSagaTakeLeading(
    actions.declaration.saveDeclarationSuccess,
    useCallback(() => {
      resetUser()
      dispatch(actions.declaration.setStep(-1))
    }, [dispatch, resetUser])
  )

  useEffect(() => {
    return () => {
      dispatch(actions.declaration.saveDeclarationReset())
    }
  }, [dispatch])

  return {
    stepPart: {
      text: t('declaration.form.stepPart.confirmation'),
    },
    html: {
      text: t('declaration.form.confirmation.text', {
        name: registrantName,
      }),
    },
    form: {
      initialValues: {},
      validationSchema: undefined,
      validateOnChange: false,
    },
    confirmationButtons: {
      modify: {
        text: t('declaration.form.confirmation.modify.label'),
        variant: ActionButtonVariant.whiteWithBorder,
        type: 'button',
        onClick: () => {
          dispatch(actions.declaration.setPreviousStep())
        },
      },
      confirm: {
        text: t('declaration.form.confirmation.confirm.label'),
        type: 'button',
        onClick: () => {
          dispatch(actions.declaration.saveDeclarationRequest())
        },
      },
    },
    errors: processedError,
  }
}
